import Header from "../../components/user/Header";

import Footer from "../../components/user/Footer";
import FeedbackSection from "../../components/user/sections/FeedbackSection";

export default function Doctors() {
  return (
    <>
      {/* Global font */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        body { margin: 0; padding: 0; }
      `}</style>
      
      {/* ── HEADER ── */}
      
      <Header />
      
      {/* ── DOCTOR SECTION ── */}
      <FeedbackSection />
      
      {/* ── FOOTER ── */}
      <Footer />{" "}
    </>
  );
}
